/* BulgarianScents — Motion pack */
(function () {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(pointer: fine)').matches;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const lerp = (a, b, t) => a + (b - a) * t;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const body = document.body;
  window.BSMotion = { flyDuration: 0 };

  /* ---------- Preloader (once per session) ---------- */
  const pre = $('#Preloader');
  if (pre) {
    let seen = false;
    try { seen = sessionStorage.getItem('bs_pre') === '1'; sessionStorage.setItem('bs_pre', '1'); } catch (e) {}
    if (seen || reduce || window.Shopify && Shopify.designMode) {
      pre.classList.add('is-hidden'); document.documentElement.classList.remove('is-loading');
    } else {
      const count = $('.preloader__count', pre);
      const t0 = performance.now(), dur = 1400;
      (function tick(now) {
        const p = clamp((now - t0) / dur, 0, 1);
        if (count) count.textContent = String(Math.round(p * 100)).padStart(3, '0');
        if (p < 1) requestAnimationFrame(tick);
        else {
          pre.classList.add('is-done');
          document.documentElement.classList.remove('is-loading');
          document.dispatchEvent(new CustomEvent('bs:loaded'));
          setTimeout(() => pre.classList.add('is-hidden'), 1100);
        }
      })(t0);
    }
  }

  if (reduce) return;

  /* ---------- Scroll progress ---------- */
  const prog = document.createElement('div');
  prog.className = 'scroll-progress'; body.appendChild(prog);

  /* ---------- Split text ---------- */
  function split(el) {
    if (el.classList.contains('is-split')) return;
    let wi = 0;
    const walk = node => {
      Array.from(node.childNodes).forEach(n => {
        if (n.nodeType === 3) {
          const parts = n.textContent.split(/(\s+)/);
          const frag = document.createDocumentFragment();
          parts.forEach(p => {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span'); w.className = 'split-w';
            const i = document.createElement('span'); i.textContent = p; i.style.setProperty('--wi', wi++);
            w.appendChild(i); frag.appendChild(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && !n.classList.contains('split-w')) walk(n);
      });
    };
    walk(el);
    el.classList.add('is-split');
  }
  const splitTargets = $$('.hero h1, .section-head h2, .story h2, .newsletter h2, .collection-hero h1, .page-head h1, .finder h2');
  splitTargets.forEach(el => { el.removeAttribute('data-anim'); el.removeAttribute('data-reveal'); split(el); });

  /* ---------- In-view observer (split, clip, footer giant) ---------- */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -10% 0px' });
  const startObserve = () => {
    $$('.is-split, [data-clip], .footer__giant').forEach(el => io.observe(el));
  };
  if (pre && !pre.classList.contains('is-hidden')) document.addEventListener('bs:loaded', () => setTimeout(startObserve, 250), { once: true });
  else startObserve();

  /* ---------- Count-up stats ---------- */
  const cio = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return; cio.unobserve(e.target);
    const el = e.target, m = el.textContent.trim().match(/^(\d+)(.*)$/);
    if (!m) return;
    const end = +m[1], suf = m[2], t0 = performance.now(), d = 1600;
    (function f(now) { const p = clamp((now - t0) / d, 0, 1), k = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(end * k) + suf; if (p < 1) requestAnimationFrame(f); })(t0);
  }), { threshold: .6 });
  $$('.hero__stat strong').forEach(el => cio.observe(el));

  /* ---------- Custom cursor ---------- */
  if (fine && body.classList.contains('has-cursor')) {
    const dot = document.createElement('div'); dot.className = 'cursor-dot';
    const ring = document.createElement('div'); ring.className = 'cursor-ring';
    ring.innerHTML = '<span>' + (body.dataset.viewLabel || 'Виж') + '</span>';
    body.append(dot, ring);
    let mx = -100, my = -100, rx = -100, ry = -100;
    window.addEventListener('pointermove', e => { mx = e.clientX; my = e.clientY; body.classList.add('cursor-on'); }, { passive: true });
    document.addEventListener('pointerleave', () => body.classList.remove('cursor-on'));
    document.addEventListener('pointerover', e => {
      const t = e.target;
      body.classList.toggle('cursor-view', !!t.closest('.card__media, .gallery__item, .family'));
      body.classList.toggle('cursor-hover', !!t.closest('a, button, summary, label, .finder__opt'));
    });
    (function loop() {
      rx = lerp(rx, mx, .18); ry = lerp(ry, my, .18);
      dot.style.transform = `translate3d(${mx}px,${my}px,0)`;
      ring.style.transform = `translate3d(${rx}px,${ry}px,0)`;
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Magnetic buttons ---------- */
  if (fine) {
    document.addEventListener('pointermove', e => {
      const b = e.target.closest('.btn, .icon-btn, .finder__opt');
      $$('.is-magnet').forEach(x => { if (x !== b) { x.style.transform = ''; x.classList.remove('is-magnet'); } });
      if (!b || b.closest('.card__quick')) return;
      const r = b.getBoundingClientRect();
      const x = (e.clientX - r.left - r.width / 2) * .28, y = (e.clientY - r.top - r.height / 2) * .38;
      b.style.transform = `translate(${x}px,${y}px)`; b.classList.add('is-magnet');
    }, { passive: true });
  }

  /* ---------- 3D tilt cards ---------- */
  if (fine) {
    document.addEventListener('pointermove', e => {
      const m = e.target.closest('.card__media');
      $$('.card__media.is-tilting').forEach(x => { if (x !== m) { x.style.transform = ''; x.classList.remove('is-tilting'); } });
      if (!m) return;
      if (!m.querySelector('.card__glare')) { const g = document.createElement('span'); g.className = 'card__glare'; m.appendChild(g); }
      const r = m.getBoundingClientRect(), px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
      m.classList.add('is-tilting');
      m.style.transform = `perspective(900px) rotateY(${(px - .5) * 12}deg) rotateX(${(.5 - py) * 12}deg) translateZ(0)`;
      m.style.setProperty('--gx', px * 100 + '%'); m.style.setProperty('--gy', py * 100 + '%');
    }, { passive: true });
  }

  /* ---------- Hero bottle: tilt + spray particles ---------- */
  const vis = $('.hero__visual');
  let spray = null;
  if (vis) {
    const target = vis.querySelector('.hero__bottle, img');
    if (target) {
      const tilt = document.createElement('div'); tilt.className = 'hero__tilt';
      target.parentNode.insertBefore(tilt, target); tilt.appendChild(target);
      const cv = document.createElement('canvas'); cv.className = 'hero__spray'; vis.appendChild(cv);
      const hint = document.createElement('div'); hint.className = 'hero__hint'; hint.textContent = vis.dataset.hint || 'Натисни флакона'; vis.appendChild(hint);
      const ctx = cv.getContext('2d');
      const colors = (vis.dataset.colors || '#ffffff,#00966e,#d62612').split(',');
      let parts = [], W = 0, H = 0, dpr = Math.min(2, window.devicePixelRatio || 1);
      const size = () => { const r = cv.getBoundingClientRect(); W = r.width; H = r.height; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
      size(); window.addEventListener('resize', size);
      const nozzle = () => { // top-right of cap
        const br = target.getBoundingClientRect(), cr = cv.getBoundingClientRect();
        return { x: br.left - cr.left + br.width * .66, y: br.top - cr.top + br.height * .08 };
      };
      spray = (n = 90) => {
        const o = nozzle();
        for (let i = 0; i < n; i++) {
          const a = -Math.PI / 4 + (Math.random() - .5) * .9, s = 2 + Math.random() * 6;
          parts.push({ x: o.x, y: o.y, vx: Math.cos(a) * s, vy: Math.sin(a) * s, r: .8 + Math.random() * 2.6, life: 1, d: .006 + Math.random() * .012, c: colors[i % colors.length] });
        }
        vis.classList.add('is-spraying'); setTimeout(() => vis.classList.remove('is-spraying'), 380);
      };
      let ambient = 0;
      (function draw() {
        ctx.clearRect(0, 0, W, H);
        if (++ambient % 9 === 0 && parts.length < 160) { // soft idle mist
          const o = nozzle(); parts.push({ x: o.x + (Math.random() - .5) * 20, y: o.y + 10, vx: (Math.random() - .3) * .6, vy: -.4 - Math.random() * .6, r: 1 + Math.random() * 1.6, life: .6, d: .004, c: colors[Math.floor(Math.random() * colors.length)] });
        }
        parts = parts.filter(p => p.life > 0);
        parts.forEach(p => {
          p.x += p.vx; p.y += p.vy; p.vx *= .965; p.vy = p.vy * .965 - .015; p.life -= p.d;
          ctx.globalAlpha = Math.max(0, p.life) * .8; ctx.fillStyle = p.c;
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r * (1.6 - p.life * .6), 0, 6.283); ctx.fill();
        });
        ctx.globalAlpha = 1;
        requestAnimationFrame(draw);
      })();
      vis.addEventListener('click', () => { spray(); hint.style.display = 'none'; });
      if (fine) {
        const hero = vis.closest('.hero');
        hero.addEventListener('pointermove', e => {
          const r = hero.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
          tilt.style.setProperty('--ry', x * 26 + 'deg'); tilt.style.setProperty('--rx', -y * 18 + 'deg');
        });
        hero.addEventListener('pointerleave', () => { tilt.style.setProperty('--ry', '0deg'); tilt.style.setProperty('--rx', '0deg'); });
      }
      // first spray after load
      const first = () => setTimeout(() => spray(120), 900);
      if (pre && !pre.classList.contains('is-hidden')) document.addEventListener('bs:loaded', first, { once: true }); else first();
      window.BSMotion.heroTilt = tilt;
    }
  }

  /* ---------- Velocity marquees ---------- */
  const marquees = $$('.marquee__track, .announcement__track').map(t => {
    t.classList.add('is-js');
    const isAnn = t.classList.contains('announcement__track');
    return { t, x: 0, base: isAnn ? .45 : .7, dir: 1, isAnn };
  });

  /* ---------- Horizontal scroll ---------- */
  const hs = $$('[data-hscroll]').map(sec => ({ sec, track: $('.families', sec), count: $('.hscroll__count', sec) }));
  const setupH = () => hs.forEach(h => {
    if (window.innerWidth < 990) { h.sec.style.height = ''; h.track.style.transform = ''; return; }
    const extra = h.track.scrollWidth - window.innerWidth + 100;
    h.extra = Math.max(0, extra);
    h.sec.style.height = (window.innerHeight + h.extra) + 'px';
  });
  setupH(); window.addEventListener('resize', setupH);

  /* ---------- Statement text ---------- */
  const statements = $$('[data-statement]').map(el => ({ el, words: $$('.w', el) }));

  /* ---------- Main scroll/raf loop ---------- */
  let lastY = window.scrollY, vel = 0;
  const heroTilt = () => window.BSMotion.heroTilt;
  (function frame() {
    const y = window.scrollY, dy = y - lastY; lastY = y;
    vel = lerp(vel, dy, .12);
    const max = document.documentElement.scrollHeight - window.innerHeight;
    prog.style.transform = `scaleX(${max > 0 ? y / max : 0})`;

    marquees.forEach(m => {
      if (Math.abs(dy) > 0.5) m.dir = dy > 0 ? 1 : -1;
      const speed = m.base * m.dir + (m.isAnn ? 0 : vel * .35);
      m.x -= speed;
      const half = m.t.scrollWidth / 2;
      if (m.x <= -half) m.x += half; if (m.x > 0) m.x -= half;
      const skew = m.isAnn ? 0 : clamp(vel * -.25, -10, 10);
      m.t.style.transform = `translate3d(${m.x}px,0,0) skewX(${skew}deg)`;
    });

    const t = heroTilt();
    if (t) {
      const hp = clamp(y / (window.innerHeight * .9), 0, 1);
      t.style.transform = `rotateX(var(--rx,0deg)) rotateY(calc(var(--ry,0deg) + ${hp * 160}deg)) translateY(${hp * 80 + Math.sin(performance.now() / 900) * 10}px) scale(${1 - hp * .25})`;
    }

    hs.forEach(h => {
      if (!h.extra) return;
      const r = h.sec.getBoundingClientRect();
      const p = clamp(-r.top / h.extra, 0, 1);
      h.track.style.transform = `translate3d(${-p * h.extra}px,0,0)`;
      if (h.count) { const n = h.track.children.length; h.count.textContent = String(Math.min(n, 1 + Math.floor(p * n * .999))).padStart(2, '0') + ' / ' + String(n).padStart(2, '0'); }
    });

    statements.forEach(s => {
      const r = s.el.getBoundingClientRect(), vh = window.innerHeight;
      const p = clamp((vh * .85 - r.top) / (r.height + vh * .35), 0, 1);
      const on = Math.floor(p * s.words.length * 1.05);
      s.words.forEach((w, i) => w.classList.toggle('on', i < on));
    });

    $$('[data-parallax]').forEach(el => {
      const r = el.getBoundingClientRect(), c = r.top + r.height / 2 - window.innerHeight / 2;
      el.style.transform = `translate3d(0,${c * -(+el.dataset.parallax || .1)}px,0)`;
    });

    requestAnimationFrame(frame);
  })();

  /* ---------- Fly to cart ---------- */
  window.BSMotion.flyDuration = 750;
  document.addEventListener('bs:added', e => {
    const form = e.detail && e.detail.form;
    const src = form && (form.closest('.card') || document.querySelector('[data-product]'));
    const img = src && src.querySelector('.card__media img, .gallery__item img, .card__media svg, .gallery__item svg');
    const cart = document.querySelector('[data-open="CartDrawer"]');
    if (!cart) return;
    const bump = () => { cart.classList.remove('cart-bump'); void cart.offsetWidth; cart.classList.add('cart-bump'); };
    if (!img) { bump(); return; }
    const a = img.getBoundingClientRect(), b = cart.getBoundingClientRect();
    const size = Math.min(a.width, a.height, 220);
    let fly;
    if (img.tagName === 'IMG') { fly = document.createElement('img'); fly.src = img.currentSrc || img.src; }
    else { fly = document.createElement('div'); fly.innerHTML = img.outerHTML; }
    fly.className = 'fly-img';
    Object.assign(fly.style, { left: a.left + a.width / 2 - size / 2 + 'px', top: a.top + a.height / 2 - size / 2 + 'px', width: size + 'px', height: size + 'px' });
    body.appendChild(fly);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    fly.animate([
      { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1 },
      { transform: `translate(${dx * .45}px,${dy - 140}px) scale(.55) rotate(-25deg)`, opacity: 1, offset: .5 },
      { transform: `translate(${dx}px,${dy}px) scale(.08) rotate(-60deg)`, opacity: .6 }
    ], { duration: 750, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = () => { fly.remove(); bump(); if (spray && window.scrollY < 50) spray(40); };
  });
})();
